import { render, staticRenderFns } from "./UserProfileHistory.vue?vue&type=template&id=5953d7fc&"
import script from "./UserProfileHistory.vue?vue&type=script&lang=js&"
export * from "./UserProfileHistory.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileHistory.vue?vue&type=style&index=0&id=5953d7fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports